import React from 'react';
import Card from './Card';

const bgMap = {
  green: 'rgba(0,214,143,0.1)',
  blue: 'rgba(59,130,246,0.1)',
  purple: 'rgba(139,92,246,0.1)',
  gold: 'rgba(245,166,35,0.1)',
};

export default function StatCard({ icon, iconColor = 'green', label, value, change }) {
  return (
    <Card style={{ padding: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1rem',
            background: bgMap[iconColor] || bgMap.green,
          }}
        >
          {icon}
        </div>
        {change != null && (
          <span
            style={{
              fontSize: '0.7rem',
              fontWeight: 600,
              padding: '2px 7px',
              borderRadius: 100,
              background: change >= 0 ? 'rgba(0,214,143,0.1)' : 'rgba(244,63,94,0.1)',
              color: change >= 0 ? '#059669' : 'var(--rose)',
            }}
          >
            {change >= 0 ? '+' : ''}{change}%
          </span>
        )}
      </div>
      <div style={{ fontSize: '1.6rem', fontWeight: 700, lineHeight: 1, marginBottom: 4, letterSpacing: '-0.02em' }}>
        {value}
      </div>
      <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{label}</div>
    </Card>
  );
}